import store from "../store";
import * as actions from "../actions";
import React from "preact";
import { useEffect, useState } from "preact/hooks";
import favoriteAssetService from "../service/favoriteAssetService";
import UploadImageCard from "./card/UploadImageCard";
import Masonry from 'react-masonry-component'
import TemplateCard from "./card/TemplateCard";
import designService from "../service/designService";
import UseTemplateModal from "./UseTemplateModal";
const { dispatch } = store;
const { goToView, goToSubview, setSelectionType } = actions;

import util from "../util";
import designDomain from "../domain/designDomain";
import Spinner from "./Spinner";
import IllustrationCard from "./card/IllustrationCard";
import StockPhotoCard from "./card/StockPhotoCard";
import imageService from "../service/imageService";

interface AsideFavoritesProps {
  view: string;
  isMobileVersion: boolean;
  uploadedImages: any[];
  setUploadedImages: (images: any[]) => void;
  isTemplate: boolean;
  hasChanges: boolean;
  designId: string;
}

export default function AsideFavorites({ uploadedImages, setUploadedImages, isTemplate, hasChanges, designId }: AsideFavoritesProps) {

  const [isLoading, setIsLoading] = useState(false);
  const [favoriteAssets, setFavoriteAssets] = useState([]);
  const [subview, setSubview] = useState('uploads');
  const [elements, setElements] = useState([] as any[]);
  const [useDesign, setUseDesign] = useState(null);
  const [useDesignModal, setUseDesignModal] = useState(false);

  useEffect(() => {
    getFavoriteAssets(subview);
  }, []);

  function getFavoriteAssets(sub: string) {
    if (isLoading) return;

    setSubview(sub);
    let type = 'upload';

    switch (sub) {
      case 'uploads':
        type = 'upload';
        break;
      case 'templates':
        type = 'template';
        break;
      case 'illustrations':
        type = 'illustration';
        break;
      case 'stock-photos':
        type = 'stock-photo';
        break;
    }

    setElements([]);
    setIsLoading(true);

    favoriteAssetService.getFavoriteAssetsByType(store.getState().memberId, type).then((response) => {
      setFavoriteAssets(response.data);

      if (sub === 'uploads') {
        const favoriteUploads = uploadedImages.filter((image: any) => {
          const isFavorite = response.data.some((asset: any) => {
            return asset.assetId === image.id;
          });
          return isFavorite;
        });

        if (favoriteUploads.length > 0) {
          setElements(favoriteUploads.map((upload: any) => (
            <UploadImageCard
              image={upload}
              uploadedImages={favoriteUploads}
              setUploadedImages={setUploadedImages}
              openCropper={() => { }}
              openAltTextModal={() => { }}
              isFavorite={true}
              showActions={false}
              toggleFavoriteCallback={() => {
                getFavoriteAssets(sub);
                upload.isFavorite = !upload.isFavorite;
              }}
            />
          )));
        }

        setIsLoading(false);
      } else if (sub === 'templates') {
        designService.getFavoriteTemplates().then((response: any) => {
          const favoriteTemplates = response.data.map((asset: any) => (
            new designDomain.Design(asset, util.sizes)
          ));

          setElements(favoriteTemplates.map((asset: any) => (
            <TemplateCard
              design={asset}
              free={asset.free}
              isFreemium={false}
              loading={false}
              useTemplate={useTemplate}
              isFavorite={true}
              showFavorite={true}
              toggleFavoriteCallback={() => getFavoriteAssets(sub)}
            />
          )));

          setIsLoading(false);
        });
      } else if (sub === 'illustrations') {
        designService.getFavoriteIllustrations().then((resp: any) => {
          const favoriteIllustrations = resp.data.map((asset: any) => (
            new designDomain.DesignIllustration(asset)
          ));

          setElements(favoriteIllustrations.map((asset: any) => (
            <IllustrationCard
              illustration={asset}
              selectionMode={false}
              selectedIllustrations={[]}
              toggleSelected={() => { }}
              showConfigureIllustrationModal={() => { }}
              isDesigner={false}
              privacyLabel={asset.privacyLabel}
              isFavorite={true}
              toggleFavoriteCallback={() => getFavoriteAssets(sub)}
            />
          )));

          setIsLoading(false);
        });
      } else if (sub === 'stock-photos') {
        if (response.data.length === 0) {
          setIsLoading(false);
          return;
        }

        imageService.searchPixabayImagesPerIds(response.data.map((asset: any) => asset.assetId).join(',')).then((response: any) => {
          const favoriteStockPhotos = response.data.map((jsonStr: string) => {
            const parsed = JSON.parse(jsonStr);
            return parsed.hits[0];
          });

          setElements(favoriteStockPhotos.map((image: any) => (
            <StockPhotoCard
              image={image}
              isFavorite={true}
              toggleFavoriteCallback={() => getFavoriteAssets(sub)}
            />
          )));

          setIsLoading(false);
        });
      }
    });
  }

  function useTemplate(design: any) {
    // if (!isTemplate && hasChanges) {
      setUseDesign(design);
      setUseDesignModal(true);
    // } else if (!hasChanges) {
      // this.updateTemplate(design);
    // }
  };

  return <div id="app-aside-graphics">
    <div id="app-aside-favorites" className="aside-favorites">
      <header>
        <nav className="main favorites-nav">
          <ul>
            <li><a className={`link ${subview === 'uploads' ? ' active' : ''}`} onClick={() => getFavoriteAssets('uploads')}>Uploads</a></li>
            <li><a className={`link ${subview === 'templates' ? ' active' : ''}`} onClick={() => getFavoriteAssets('templates')}>Templates</a></li>
            <li><a className={`link ${subview === 'illustrations' ? ' active' : ''}`} onClick={() => getFavoriteAssets('illustrations')}>Illustrations</a></li>
            <li><a className={`link ${subview === 'stock-photos' ? ' active' : ''}`} onClick={() => getFavoriteAssets('stock-photos')}>Stock Photos</a></li>
          </ul>
        </nav>
      </header>

      <div className="favorites-list scroller">
        <div className={`
        ${subview === 'uploads' ? 'components images' : ''}
        ${subview === 'templates' ? 'designs' : ''}
        ${subview === 'illustrations' ? 'components images illustrations' : ''}
        ${subview === 'stock-photos' ? 'components images' : ''}
      `}>
          {isLoading && <Spinner />}

          {elements.length === 0 && !isLoading && <div className="no-favorites">No favorites yet.</div>}

          {!isLoading && subview === 'illustrations' && (
            <div className="illustration-items">
              {elements}
            </div>
          )}

          {!isLoading && subview !== 'illustrations' && (
            <Masonry updateOnEachImageLoad={false} className={'masonry-grid'}>
              {elements}
            </Masonry>
          )}
        </div>
      </div>
    </div>

    <UseTemplateModal
      designId={designId}
      hasChanges={hasChanges}
      design={useDesign}
      open={useDesignModal}
      onModalClose={() => setUseDesignModal(false)} />
  </div>
}
